import { createFileRoute } from '@tanstack/react-router'
import { Sessoes } from '@/features/portal/sessoes'
import { PortalShell } from '@/features/portal/shell'

/** `/portal`: as sessões de quem é atendido. A sala em si é `/portal/sala`. */
export const Route = createFileRoute('/_portal/portal')({
  component: function Portal() {
    return (
      <PortalShell title="Suas sessões">
        <Sessoes />
      </PortalShell>
    )
  },
})
